<template>
  <div class="chat-input-container">
    <input
      :placeholder="placeholder"
      type="text"
      class="chat-input"
      @keyup.enter="handleSend"
      :value="inputValue"
      @input="updateInput"
      :disabled="isLoading"
    />
    <button
      class="send-button"
      @click="handleSend"
      :disabled="isLoading || !inputValue.trim()"
    >
      {{ sendButtonText }}
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ChatInput',
  props: {
    placeholder: {
      type: String,
      default: 'Digite sua dúvida ou mensagem.',
    },
    sendButtonText: {
      type: String,
      default: 'Enviar',
    },
  },
  computed: {
    ...mapGetters('chat', ['inputValue', 'isLoading']),
  },
  methods: {
    ...mapActions('chat', ['sendMessage', 'updateInputValue']),
    updateInput(event) {
      this.updateInputValue(event.target.value);
    },
    async handleSend() {
      if (this.isLoading || !this.inputValue.trim()) {
        return;
      }
      try {
        await this.sendMessage(this.inputValue);
        this.$emit('sent');
      } catch (error) {
        this.$emit('error', error);
      }
    },
  },
};
</script>

<style scoped>
.chat-input-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f5f5f5;
  border-radius: 24px;
  padding: 0;
}

.chat-input {
  flex: 1;
  border: 0px;
  margin-left: 20px;
  background-color: #f5f5f5;
  height: 5vh;
  font-size: 18px;
  font-family: "Montserrat", Sans-serif;
}

.chat-input:focus {
  outline: none;
}

.chat-input::placeholder {
  color: #173557;
}

.chat-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.send-button {
  padding: 10px;
  margin: 1vw;
  background-color: #0B385B;
  color: #fff;
  border-radius: 25px;
  border: none;
  cursor: pointer;
  font-family: "Montserrat", Sans-serif;
  font-size: 16px;
}

.send-button:hover:not(:disabled) {
  background-color: #0a2d47;
}

.send-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media only screen and (max-width: 600px) {
  .chat-input {
    font-size: 14px;
  }
}
</style>

